import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import Cards from '../../../common/cards/Cards';
import { Panel, PanelGroup } from 'react-bootstrap';
import { withStyles } from '@material-ui/core/styles';
import Radio from '@material-ui/core/Radio';
import styles from '../../../common/customStylesRadioButton';
import { CARD_METHOD, DRIVER_METHOD } from 'components/components/booking/Summary/utils/PaymentMethodsConstants';
import T from 'components/common/translations/Translate';

class PaymentMethods extends Component {

  constructor(props, context) {
    super();

    this.state = {
      showModal: false,
      activeKey: null,
    };

    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.onClickPreventDefault = this.onClickPreventDefault.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
  }

  handleOpenModal(e) {
    e.preventDefault();
    this.setState({ showModal: true });
  }

  handleChange = (event, option) => {
    this.props.changePaymentMethod(option);
    this.props.setCardId(null);
  }

  handleCloseModal() {
    this.setState({ showModal: false });
  }

  onClickPreventDefault(e) {
    this.setState({ showModal: false });
    e.preventDefault();
  }

  handleSelect(activeKey) {
    this.setState({ activeKey });
  }

  render() {
    return (
      <Fragment>
        <div className="list-accordion">
          <PanelGroup
            accordion
            id="accordion-payments"
            activeKey={this.state.activeKey}
            onSelect={this.handleSelect}
          >
            <Panel eventKey="1">
              <Panel.Heading onClick={(e) => this.handleChange(e, CARD_METHOD)}>
                <Panel.Title toggle>
                  <label htmlFor="pay-card">
                    <div className="label__desc">
                    <div><T>content.bookingStep4.summary.payUsingCard</T></div>
                      <div>
                        <Radio
                          id="pay-card"
                          value={CARD_METHOD}
                          checked={this.props.paymentMethod === CARD_METHOD}
                          classes={{
                            root: this.props.classes.root,
                            checked: this.props.classes.checked,
                          }}
                          className="radio-button"
                          name="payment"
                        />
                      </div>
                    </div>
                  </label>
                </Panel.Title>
              </Panel.Heading>
              <Panel.Body collapsible>
                {this.props.showCards &&
                  <Cards
                    csk={this.props.csk}
                    cardErrors={this.props.cardErrors}
                    createPaymentIntent={this.props.createPaymentIntent}
                    saveCard={this.props.saveCard}
                    onChangeSaveCard={this.props.onChangeSaveCard}
                    selectedCardId={this.props.selectedCardId}
                    setCardId={this.props.setCardId}
                    locale={this.props.locale}
                    resetCardElement={this.props.resetCardElement}
                  />
                }
              </Panel.Body>
            </Panel>

            <Panel eventKey="2">
              <Panel.Heading onClick={(e) => this.handleChange(e, DRIVER_METHOD)}>
                <Panel.Title toggle>
                  <label htmlFor="pay-driver">
                    <div className="label__desc">
                      <div><T>content.bookingStep4.summary.payToDriver</T></div>
                      <div>
                        <Radio
                          id="pay-driver"
                          value={DRIVER_METHOD}
                          checked={this.props.paymentMethod === DRIVER_METHOD}
                          classes={{
                            root: this.props.classes.root,
                            checked: this.props.classes.checked,
                          }}
                          className="radio-button"
                          name="payment"
                        />
                      </div>
                    </div>
                  </label>
                </Panel.Title>
              </Panel.Heading>
            </Panel>

          </PanelGroup>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    locale: state.app.locale
  };
};

export default connect(mapStateToProps)(withStyles(styles)(PaymentMethods));